import React from 'react';
import { OperationType } from 'components/RecordsListView/constants';
import {
  SCROLL_CONTAINER_STYLES,
  NOTES_CONTENT_INLINE_STYLES,
  EMPTY_STATE_INLINE_STYLES
} from './constants';

interface NotesTabProps {
  notesInfo: {
    notes: string;
  };
  type?: OperationType;
}

const NotesTab = ({ notesInfo, type }: NotesTabProps) => {
  const { notes } = notesInfo;

  const scrollStyles =
    type === OperationType.WORK_ORDER
      ? { ...SCROLL_CONTAINER_STYLES, maxHeight: 'calc(100vh - 379px)' }
      : SCROLL_CONTAINER_STYLES;

  return (
    <div data-testid="notes-tab" className="p-6">
      <div style={scrollStyles}>
        {notes ? (
          <div
            data-testid="notes-content"
            className="text-sm font-normal whitespace-pre-wrap"
            style={NOTES_CONTENT_INLINE_STYLES}
          >
            {notes}
          </div>
        ) : (
          <p
            data-testid="no-notes"
            className="text-sm font-normal"
            style={EMPTY_STATE_INLINE_STYLES}
          >
            No notes entered
          </p>
        )}
      </div>
    </div>
  );
};

export default NotesTab;
